// extracted by mini-css-extract-plugin
export var wrapper = "benefits-module--wrapper--8yGsY";
export var list = "benefits-module--list--57drW";
export var item = "benefits-module--item--pillU";
export var itemTitle = "benefits-module--itemTitle--qGOIl";
export var itemDescription = "benefits-module--itemDescription--V5pG-";